export default [
  {
    _id: 'search-people-001',
    source: 'mock-people',
    name: 'Lydia Brooks',
    relationshipHint: 'Maternal Aunt',
    reliability: 'verified',
    city: 'Hutchinson',
    state: 'KS',
    matchingMemberId: 'member-004',
    childId: 'child-001',
    provenance: ['voter-rolls', 'public-records'],
    confidence: 0.82
  },
  {
    _id: 'search-people-002',
    source: 'mock-people',
    name: 'Tyler Brooks',
    relationshipHint: 'Cousin (18)',
    reliability: 'candidate',
    city: 'Hutchinson',
    state: 'KS',
    matchingMemberId: null,
    childId: 'child-001',
    provenance: ['social-graph'],
    confidence: 0.67
  },
  {
    _id: 'search-people-003',
    source: 'mock-people',
    name: 'Angela Ward',
    relationshipHint: 'Church Mentor',
    reliability: 'reported',
    city: 'Wichita',
    state: 'KS',
    matchingMemberId: null,
    childId: 'child-001',
    provenance: ['community-partner'],
    confidence: 0.54
  }
];
